<template>
	<div :class="['carWarp',{'cur':isShowCarList}]">
		<section id="brandWarp" class="carWarpItem brandWarp">
			<div id="headerTag" class="clearfix headerTag">
				<a @click="isShowCarList = false" class="fl back" href="javascript:void(0)">返回</a>
				<span style="margin-left:2rem;">全部品牌</span>
			</div>
			<div id="carContentBrand" class="carContent carContentBrand">
				<!--<div class="choiceCarTag">
					热门品牌
				</div>
				<div class="hotCarList">
					<div v-if="index<8" class="hotCarListItem" v-for="(item,index) in hotCarList" @click="showCarStyle(item.id)">
						<div>
							<img class="hotCarList-img" :src="item.logo ? (commmonWebConfig.picHost + item.logo) : commmonWebConfig.webCommonUtils+'/img/mapply/comparison/logo1.png'" />
						</div>
						<div v-text="item.name"></div>
					</div>
				</div>-->
				<div class="brandListWarp">
					<dl v-for="(item,index) in brandList" class="brandList">
						<dt class="choiceCarTag" v-text="index"></dt>
						<dd @click="showCarStyle(itemIn.id)" class="brandListItem" v-for="(itemIn,indexIn) in item">
							<img :src="itemIn.logo ? (commmonWebConfig.picHost + itemIn.logo) : commmonWebConfig.webCommonUtils+'/img/mapply/comparison/logo1.png'" />
							<span class="brandListItemName" v-text="itemIn.name"></span>
						</dd>
					</dl>
				</div>
				<div class="letter-wrap">
					<ul id='letter-Ul' class="letter-Ul">
						<li @click="scrollWinTag(0)">#</li>
						<li @click="scrollWinTag(key+1)" v-for="(item,index,key) in brandList">
							{{index}}
						</li>
					</ul>
				</div>
			</div>
		</section>
		<section id="carStyleWarp" :class="['carWarpItem','carStyleWarp',{'cur':isShowCarStyle}]">
			<div class="clearfix headerTag">
				<a @click="showCarList()" class="fl back" href="javascript:void(0)">返回</a>
				<span style="margin-left:2rem;">选择车型</span>
			</div>
			<div id="carContentCarStyle" class="carContent carContentCarStyle">
				<div class="carStyleHeader">
					<img :src="carStyleList.curBrand.logo ? (commmonWebConfig.picHost + carStyleList.curBrand.logo) : commmonWebConfig.webCommonUtils+'/img/mapply/comparison/logo.png'"/>
					<span>{{carStyleList.curBrand.name}}</span>
					<input type="text" hidden="hidden" id="brandid" :value="carStyleList.curBrand.id"/>
					<input type="text" hidden="hidden" id="brandname" :value="carStyleList.curBrand.name"/>
				</div>
				<dl class="carStyleList" v-for="(item,index) in carStyleList.curlist">
					<dt v-text="item.name"></dt>
					<dd @click="showModel(itemIn.id)" class="clearfix" v-for="(itemIn,indexIn) in item.list">
						<input type="text" hidden="hidden" id="styleid" :value="itemIn.id"/>
						<input type="text" hidden="hidden" id="stylename" :value="itemIn.name"/>
						<div class="fl">
							<img :src="itemIn.logo ? (commmonWebConfig.picHost + itemIn.logo) : commmonWebConfig.webCommonUtils+'/img/mapply/comparison/logo.png'"/>
						</div>
						<div class="fl">
							<p class="name">{{itemIn.name}}</p>
							<p class="price">{{itemIn.price}}</p>
						</div>
					</dd>
				</dl>
			</div>
		</section>
		<section id="modelWarp" :class="['carWarpItem','modelWarp',{'cur':isShowModel}]">
			<div class="clearfix headerTag">
				<a @click = "showCarStyle(null)" class="fl back" href="javascript:void(0)">返回</a>
				
				<span style="margin-left:2rem;">选择车款</span>
				
			</div>
			<div>
				<div id="carContentModel" class="zanwu" v-if="modelList.group.length == 0">
					暂无车款
				</div>
				<div v-else id="carContentModel" class="carContent carContentModel">
					<div class="carContentModel-Tag">

						<span :class="[{'cur':item.active}]" v-for="(item,index) in modelList.group" @click="checkModel(item.year)">
							
							<!--<span style="margin-left:-1rem;">{{modelList.name}}</span>-->
							{{item.year}}款
							<em></em>
						</span>
					</div>
					<ul v-show="item.active" v-for="(item,index) in modelList.group" class="carContentModel-con">
						<li @click="checkModelId(itemIn,index)"  v-for="(itemIn,indexIn) in item.list">
							<input type="text" hidden="hidden" id="styleSeriesid" :value="itemIn.id"/>
							<input type="text" hidden="hidden" id="styleSeriesname" :value="itemIn.name"/>
							<p class="carContentModel-con-name" v-text="itemIn.name"></p>
							
							<span class="carContentModel-con-transmission" v-text="itemIn.transmission"></span><em style="color: red;margin-left: 0.4rem;">{{itemIn.referPrice}}万元</em>
						</li>
					</ul>
				</div>
			</div>
			
		</section>
	</div>

</template>
<style scoped lang="less">
@import url('../../../assets/less/common.less');
.headerTag{
	top:0;
	left:0;
	width:100%;
	padding:0;
}
.carWarp{
	display: none;
	position: absolute;
	top:0;
	left:100%;
	width:100%;
	height:100%;
	background: #adaeb1;
	transition: left 0.5s;
	-moz-transition: left 0.5s; /* Firefox 4 */
	-webkit-transition: left 0.5s; /* Safari 和 Chrome */
	-o-transition: left 0.5s; /* Opera */
	.carWarpItem{
		position: relative;
		width:70%;
		height:100%;
		overflow: hidden;
		background: #fff;
		left:30%;
		.carContent{
			position: relative;
			overflow-x: hidden;
			overflow-y: auto;
			//-webkit-overflow-scrolling:touch;
			//overflow-scrolling:touch;
			.letter-wrap{
				position: fixed;
				top:1.173333rem;
				right:0;
				overflow: scroll;
				background: #fff;
			    ul.letter-Ul {
			    	li{
			    	    padding: 2px 6px;
				    }
			    }
			   
			}
		}
	}
	.choiceCarTag{
		.px2px(font-size,30px);
		background: #fff;
		padding:0.2rem 0.4rem;
	}

	/*热门车型*/

	.hotCarListItem{
		width:25%;
		display: inline-block;
		text-align: center;
		background: #fff;
		padding:0.2rem 0;
		.hotCarList-img{
			width:1.066667rem;
			height:1.066667rem;
		}
	}

	/*品牌列表*/
	.brandListWarp{
		margin-top: 0.266667rem;
		.brandList{
			background: #fff;
			.brandListItem{
				position: relative;
				margin:0 0.2rem;
				height:1.5rem;
				border-bottom: 1px solid #eaeaea;
				img{
					position: absolute;
					left:0.2rem;
					top:50%;
					margin-top: -0.533333rem;
					width:1.066667rem;
					height:1.066667rem;
					vertical-align: middle;
				}
				.brandListItemName{
					display: inline-block;
					.px2px(font-size,30px);
					line-height: 1.5rem;
					margin-left: 1.4rem;
				}
			}
		}
	}
	.carStyleWarp,.modelWarp{
		position: absolute;
		display: none;
		top:0;
		left:30%;
	}
	.carStyleWarp.cur,.modelWarp.cur{
		display: block;
		left:30%;
	}

	/********车型*********/
	.carContentCarStyle{
		.carStyleHeader{
			height:1.2rem;
			line-height: 1.2rem;
			.px2px(font-size,30px);
			padding:0.2rem 0;
			margin:0 0.4rem;
			border-bottom:1px solid #eaeaea;
			img{
				width:1.2rem;
				vertical-align: middle;
			}
		}
		.carStyleList{
			margin:0 0.4rem;
			dt{
				.px2px(font-size,26px);
				padding: 0.4rem 0;
			}
			dd{
				padding:0.4rem 0;
				border-bottom:1px solid #eaeaea;
				img{
					width:1.2rem;
					height:auto;
					vertical-align: middle;
					margin-right:0.4rem;
				}
				.name{
					.px2px(font-size,30px);
					margin-bottom: 0.1rem;
				}
				.price{
					.px2px(font-size,24px);
					color:#666;
				}
			}
		}
	}
	/********车款*********/
	.modelWarp .zanwu{
		color:#ccc;
		.px2px(font-size,40px);
		padding:0.8rem 0;
		text-align: center;
	}
	.carContentModel-Tag {
		position: fixed;
		background: #fff;
		padding:0 0.4rem;
		width:100%;
		box-sizing: border-box;
		span{
			position: relative;
			display: inline-block;
			padding:0.2rem;
			text-align: center;
			.px2px(font-size,32px);
		}
		span.cur{
			em{
				position: absolute;
				bottom:0;
				left:50%;
				display: inline-block;
				width:0.45rem;
				border-bottom:1px solid #ff3938;
				margin-left:-0.225rem;
			}
			
		}
	}
	.carContentModel-con{
		margin-top: 1rem;
		li{
			margin:0 0.4rem;
			padding:0.4rem 0;
			border-bottom:1px solid #eaeaea;
		}
		.carContentModel-con-name{
			.px2px(font-size,30px);
			margin-bottom: 0.1rem;
		}
		.carContentModel-con-transmission{
			.px2px(font-size,24px);
			color:#999;
		}
	}

	
	
}
.carWarp.cur{
	display: block;
	left:0
}
/*.headerTag .back {
    background: url(../../../img/mapply/calculator/back.png);
    background-size: 100% 100%;
    text-indent: -99999px;
    width: .56rem;
    height: .5rem;
}*/
.fl {
    float: left;
    display: inline-block;
}




</style>
<script>
	import MsgBus from "../../../assets/bus/bus.js"	
	import { Toast } from 'mint-ui';
	import { Indicator } from 'mint-ui';
	export default {
		name: 'comparison',
		data:function() {
			return {
				//记录当前滚动距离
				scrollParams:{
					winScrollTop:0,
					tagOffsetTop:[],
				},
				//是否展示品牌车型内容
				isShowCarList:false,
				isShowCarStyle:false,
				isShowModel:false,
				carInfor:{
					name:'',
					styleName:'',
					year:'',
					showLoadContent:false,
					brandid:'',
					brandname:'',
					styleid:'',
					stylename:'',
					styleSeriesid:'',
					styleSeriesname:'',
				},
				/****品牌****/
				hotCarList:[
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// },
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// },
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// },
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// },
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// },
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// },
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// },
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// },
					// {
					// 	id:1,
					// 	name:"北京现代",
					// 	logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// }
				],
				brandList:{
					// "A":[
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		},
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		}
					// 	],
					// "B":[
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		},
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		},
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		}
					// 	],
					// "C":[
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		},
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		}
					// 	],
					// "D":[
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		},
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		}
					// 	],
					// "E":[
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		},
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		},
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		}
					// 	],
					// "F":[
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		},
					// 		{
					// 			id:1,
					// 			name:"北京现代",
					// 			logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg"
					// 		}
					// 	]
					},
				/********车型********/
				carStyleList: {
					curBrand:{},
					curlist:[]
					// curBrand:{
					// 	id:0,
					// 	name:'北京现代',
					// 	logo:'http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg'
					// },
					// curlist:[
					// 	{
					// 		name:'北京现代',
					// 		list:[
					// 			{
					// 				id:1,
					// 				name:"北京现代",
					// 				logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg",
					// 				price:'2万-3万'
					// 			},
					// 			{
					// 				id:1,
					// 				name:"北京现代",
					// 				logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg",
					// 				price:'2万-3万'
					// 			}
					// 		]
					// 	},
					// 	{
					// 		name:'北京现代',
					// 		list:[
					// 			{
					// 				id:1,
					// 				name:"北京现代",
					// 				logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg",
					// 				price:'2万-3万'
					// 			},
					// 			{
					// 				id:1,
					// 				name:"北京现代",
					// 				logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg",
					// 				price:'2万-3万'
					// 			}
					// 		]
					// 	},
					// 	{
					// 		name:'北京现代',
					// 		list:[
					// 			{
					// 				id:1,
					// 				name:"北京现代",
					// 				logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg",
					// 				price:'2万-3万'
					// 			},
					// 			{
					// 				id:1,
					// 				name:"北京现代",
					// 				logo:"http://t.pic3.tuanche.com/car/20150420/14295250831087278_s.jpg",
					// 				price:'2万-3万'
					// 			}
					// 		]
					// 	}
					// ]
				},
				/****车款信息*****/
				modelList:{
					id: -1,
					name: '',
					group: []
						// "2006":{
						// 	active:true,
						// 	list:[
						// 		{
						// 			id: 38293,
						// 			name: '车款名称',
						// 			transmission: '7挡 双离合'
						// 		},
						// 		{
						// 			id: 34238,
						// 			name: '车款名称',
						// 			transmission: '7挡 双离合'
						// 		}
						// 	]
						// },
						// "2007":{
						// 	active:false,
						// 	list:[
						// 		{
						// 			id: 347342,
						// 			name: '车款名称2007',
						// 			transmission: '7挡 双离合'
						// 		},
						// 		{
						// 			id: 4332894,
						// 			name: '车款名称2007',
						// 			transmission: '7挡 双离合'
						// 		}
						// 	]
						// },
						// "2008":{
						// 	active:false,
						// 	list:[
						// 		{
						// 			id: 34732,
						// 			name: '车款名称2008',
						// 			transmission: '7挡 双离合'
						// 		},
						// 		{
						// 			id: 43579,
						// 			name: '车款名称2008',
						// 			transmission: '7挡 双离合'
						// 		}
						// 	]
						// }
					//}
				},
//				seleted:0,
//				fullpage:false,
//				loadpage:false,
				resultPage:false,
			}
		},
		mounted: function(){
		},
		methods: {
			initSide:function(showCom,showResult){
				var self =this;
//				self.seleted=seleted;
//				self.fullpage=full;
//				self.loadpage=load;
				self.carInfor.showLoadContent=showCom;
				self.resultPage=showResult;
//				alert(seleted);
//				alert(self.fullpage);
//				alert(self.loadpage);
				this.initWeb();

					
			},
			initWeb:function(){
				var self = this;
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.comparisonBrandList,
					type:"get",
					success:function(data){
						if(data.responseHeader.status == 200){
							self.hotCarList = data.response.result.hotCarList;
							for(var i in data.response.result.brandList){
								self.$set(self.brandList,i,data.response.result.brandList[i]);
								self.showCarList();
								setTimeout(function(){
									self.setContent();
									self.getTagOffsetTop();
								},1000);
							}	
						}
					},
					error:function(){}
				})
			},
			setContent:function(){
				var self = this;
				var oCarContentBrand = document.getElementById("carContentBrand");
				var oCarContentCarStyle = document.getElementById("carContentCarStyle");
				var oCarContentModel = document.getElementById("carContentModel");
				var oLetterUl = document.getElementById("letter-Ul");
				var winHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//初始化carContent的高度
				var headerTagHeight = document.getElementById("headerTag").offsetHeight;
				oCarContentBrand.style.height = (winHeight - headerTagHeight) + "px";
				oCarContentCarStyle.style.height = (winHeight - headerTagHeight) + "px";
				oCarContentModel.style.height = (winHeight - headerTagHeight) + "px";
				oLetterUl.style.height = (winHeight - headerTagHeight) + "px";

			},
			//记录所有便签距离页面顶部的距离
			getTagOffsetTop:function(){
				var oCarInfoContent = document.getElementById("carContentBrand");
				var oCarInfoContentDl = oCarInfoContent.getElementsByClassName("choiceCarTag");
				for(var i=0;  i < oCarInfoContentDl.length; i++){
					this.scrollParams.tagOffsetTop.push(oCarInfoContentDl[i].offsetTop);
				}
			},
			//页面按照点击滚动到锚点
			scrollWinTag:function(index){
				$(document.getElementById("carContentBrand")).scrollTop(this.scrollParams.tagOffsetTop[index]);
			},

			//展示侧拉框
			closeAll:function(){
				this.isShowCarList = false;
				this.isShowCarStyle = false;
				this.isShowModel = false;
			},
			showCarList:function(){
				this.isShowCarList = true;
				this.isShowCarStyle = false;
				this.isShowModel = false;
			},
			showCarStyle:function(id){
				var self = this;
				if(id){
					Indicator.open({
					  text: 'Loading...',
					  spinnerType: 'fading-circle'
					});
					this.ajaxSubmit.ajax({
						url:this.commmonWebConfig.tuancheapi + this.ajaxSubmit.allUrl.comparisonCarStyleList,
						type:"get",
						data:{
							cmId:id
						},
						success:function(data){
							Indicator.close()
							self.isShowCarList = true;
							self.isShowCarStyle = true;
							self.isShowModel = false;
							if(data.responseHeader.status == 200){
								console.log();
								self.carStyleList.curBrand = data.response.result.curBrand;
								self.carStyleList.curlist = data.response.result.curlist;
								console.log(data.response.result.curBrand);	
							}
						},
						error:function(){
							Indicator.close()
						}
					})
				}else{
					self.isShowCarList = true;
					self.isShowCarStyle = true;
					self.isShowModel = false;
				}
				

			},
			showModel:function(id){
				var self = this;
				Indicator.open({
				  text: 'Loading...',
				  spinnerType: 'fading-circle'
				});
				this.ajaxSubmit.ajax({
					url:this.commmonWebConfig.tuancheapi + this.ajaxSubmit.allUrl.comparisonModelList,
					type:"get",
					data:{
						csId:id
					},
					success:function(data){
						Indicator.close()
						self.isShowCarList = true;
						self.isShowCarStyle = true;
						self.isShowModel = true;
						if(data.responseHeader.status == 200){
							self.modelList.id = data.response.result.id;
							self.modelList.name = data.response.result.name;
							self.modelList.group = [];
							if(data.response.result.group.length > 0){
								//self.modelList.group = data.response.result.group;
								for(var j in data.response.result.group){
									if(j < 4){
										self.$set(self.modelList.group,j,data.response.result.group[j]);
										if( j == 0){
											self.$set(self.modelList.group[j],"active",true)
										}else{
											self.$set(self.modelList.group[j],"active",false)
										}
									}
								};
							}
							
						}
					},
					error:function(){
						Indicator.close()
					}
				})
			},

			//选择车款年份
			checkModel:function(index){
				for(var i in this.modelList.group){
					//console.log(this.modelList.group[i].year);
					if(this.modelList.group[i].year == index){
						this.modelList.group[i].active = true;
					}else{
						this.modelList.group[i].active = false;
					}
				}
				console.log(this.modelList);
			},
			//选择车款Id
			checkModelId:function(item,year){
				var self=this;
				item.year = year;
//				this.$emit("checkModelId",item);
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.comparisonListbycarids,
					type:"get",
					data:{
						carIds:item.id 
					},
					success:function(data){
						if(data.responseHeader.status == 200){
							//console.log(data);
							self.carInfor.name=data.response.result[0].carName;
							self.carInfor.styleName=data.response.result[0].carStyleName;
							self.carInfor.year=data.response.result[0].year;
							self.carInfor.referPrice=data.response.result[0].referPrice;
//							alert(self.carInfor.referPrice);
							self.carInfor.brandid=$("#brandid").val();
							self.carInfor.brandname=$("#brandname").val();
							self.carInfor.styleid=self.modelList.id;
							self.carInfor.stylename=self.modelList.name
							self.carInfor.styleSeriesid=data.response.result[0].id;
							self.carInfor.styleSeriesname=data.response.result[0].carName;
//							console.log($("#brandid").val());
//							console.log($("#brandname").val());
//							console.log($("#styleid").val());
//							console.log($("#stylename").val());
//							console.log($("#styleSeriesid").val());
//							console.log($("#styleSeriesname").val());
							if(self.resultPage==false){
								MsgBus.$emit('msgFull', self.carInfor);
							}else{
								MsgBus.$emit('msgFullInfo', self.carInfor);
							}
							
						}
					},
					error:function(){
					}
				})
				//关闭
				this.closeAll();
			}

		}
	}
</script>


// WEBPACK FOOTER //
// src/components/calculator/markCar/markC.vue